export const defaultTitle = 'Jigsaw Nation the best place to buy jigsaw puzzles online';
export const defaultOgTitle = 'Jigsaw Nation the best place to buy jigsaw puzzles online';
export const defaultOgDescription = 'Jigsaw Nation the best place to buy jigsaw puzzles online';
export const defaultDescription = 'Jigsaw Nation the best place to buy jigsaw puzzles online';

// Minimum number of products required on a search page to be indexed
export const SEARCH_NOINDEX_THRESHOLD = 3;
